import { render, staticRenderFns } from "./LessonPreparationCenterPage.vue?vue&type=template&id=628110a7&scoped=true"
import script from "./LessonPreparationCenterPage.vue?vue&type=script&lang=js"
export * from "./LessonPreparationCenterPage.vue?vue&type=script&lang=js"
import style0 from "./LessonPreparationCenterPage.vue?vue&type=style&index=0&id=628110a7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "628110a7",
  null
  
)

export default component.exports